import { useQuery } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'
import type { components } from '@/lib/generated/api-types'

// Type exports for convenience
export type CacheStatusResponse = components['schemas']['CacheStatusResponse']
export type CacheConfig = components['schemas']['CacheConfig']
export type CacheMode = components['schemas']['CacheMode']

// Get cache status (auto-refreshes when enabled)
export function useCacheStatus(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.cache.status,
    queryFn: async () => {
      const { data, error } = await client.GET('/api/v1/cache/status')
      if (error) throw error
      return data as unknown as CacheStatusResponse
    },
    staleTime: 0,
    refetchInterval: enabled ? 2000 : false,
    enabled,
  })
}

// Get cache configuration
export function useCacheConfig() {
  return useQuery({
    queryKey: queryKeys.cache.config,
    queryFn: async () => {
      const { data, error } = await client.GET('/api/v1/cache/config')
      if (error) throw error
      return data as unknown as CacheConfig
    },
    staleTime: 10_000,
  })
}
